"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormValidatorUtil = void 0;
const DOM_1 = require("../DOM");
const Form_1 = require("../../../../app/controls/Form/Form");
class FormValidatorUtil {
    static checkFormIsValid(form) {
        const changed = DOM_1.DOM.Parser.getDataByNameFromElementOrNull('valid', form);
        if (changed === null) {
            return true;
        }
        return changed === 'yes';
    }
    static getFormSubmit(params) {
        if (params.forceSubmitButton) {
            return params.forceSubmitButton;
        }
        const submitWithName = params.form.querySelector(`[name="_submit"]`);
        const submitWithType = params.form.querySelector(`[type="submit"]`);
        if (!submitWithName && !submitWithType) {
            console.warn('Missing form submit element!');
            return null;
        }
        return (submitWithName ?? submitWithType);
    }
    static isEditForm(options) {
        return options.form.classList.contains('editForm');
    }
    static checkFormIsChanged(options) {
        if (!FormValidatorUtil.isEditForm(options)) {
            return true;
        }
        const changed = DOM_1.DOM.Parser.getDataByNameFromElementOrNull('changed', options.form);
        if (changed === null) {
            return true;
        }
        return changed === 'yes';
    }
    static checkFormIsChangedForElement(form) {
        return this.checkFormIsChanged({ form: form });
    }
    static checkFormChanged(options) {
        if (!FormValidatorUtil.isEditForm(options)) {
            return true;
        }
        const inputs = this.getAllInputs(options);
        const formInputsCountOnInit = parseInt(DOM_1.DOM.Parser.getDataByNameFromElement('inputs', options.form));
        if (formInputsCountOnInit !== inputs.length) {
            return true;
        }
        const formDataCurrent = Form_1.ControlsForm.Controller.getFormData(options.form);
        for (let index = 0; index < inputs.length; ++index) {
            const input = inputs[index];
            if (!input.hasAttribute('data-current')) {
                continue;
            }
            const isInteger = input.hasAttribute('data-integer');
            const isCheckbox = input.type === 'checkbox';
            const current = DOM_1.DOM.Parser.getDataByNameFromElementOrNull('current', input);
            const currentValue = isInteger && current
                ? parseInt(current)
                : (isCheckbox && current ? current === "true" : current);
            const newValue = formDataCurrent[input.name] ?? (input.value.trim().length > 0 ? input.value.trim() : null);
            if (currentValue !== newValue) {
                return true;
            }
        }
        return false;
    }
    static updateFormState(options) {
        const changed = FormValidatorUtil.checkFormChanged(options);
        options.form.dataset.changed = changed ? 'yes' : 'no';
        let valid = !DOM_1.DOM.Parser.checkFormInvalid(options.form);
        options.form.dataset.valid = valid ? 'yes' : 'no';
        const submit = FormValidatorUtil.getFormSubmit(options);
        if (!submit) {
            return;
        }
        submit.disabled = (FormValidatorUtil.isEditForm(options) && !changed) || !valid;
    }
    static getAllInputs(options) {
        return DOM_1.DOM.Parser.getHtmlElementsByQuery("input:not(.dropdown-input):not(.items-placeholder):not(.tomselect-checkbox), textarea, select", options.form, true);
    }
    static getAllInputsForFormElement(form) {
        return this.getAllInputs({ form: form });
    }
}
exports.FormValidatorUtil = FormValidatorUtil;
